import type { MeasuredAttempt } from "../../domain/challenge/measured-types.js";
import {
  requireRound,
  scheduleAutoSync,
  type ActionContext,
} from "./round-workspace-sync.js";

export interface MeasuredWorkspaceActions {
  setMeasuredAttempt(
    participantId: string,
    attemptNumber: number,
    entry: MeasuredAttempt,
  ): Promise<void>;
}

export function measuredActions(
  context: ActionContext,
  run: (action: () => Promise<void>) => Promise<void>,
): MeasuredWorkspaceActions {
  return {
    setMeasuredAttempt: (participantId, attemptNumber, entry) =>
      run(async () => {
        const snapshot = requireRound(context);
        context.setSnapshot(
          await context.engine.setMeasuredAttempt(
            snapshot.roundId,
            participantId,
            attemptNumber,
            entry,
          ),
        );
        context.setQueued(true);
        context.setMessage("Attempt saved on this device.");
        scheduleAutoSync(context);
      }),
  };
}
